import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
} from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import {
  provideRouter,
  Routes,
  withNavigationErrorHandler,
} from '@angular/router'
import Echo, { EchoOptions } from 'laravel-echo'
import Pusher, { Options } from 'pusher-js'
import { BROADCAST_FACTORY } from './modules/broadcasts/tokens/broadcast'
import { CoreModule } from './modules/core/core.module'
import { Authorised } from './modules/core/injectables/authorised'
import { Unauthorised } from './modules/core/injectables/unauthorised'
import { LOCAL_STORAGE } from './modules/core/tokens/local-storage'
import { WINDOW } from './modules/core/tokens/window'
import { GlobalErrorHandler } from './modules/core/utilities/global-error-handler'

const routes: Routes = [
  {
    path: 'portal',
    loadChildren: () =>
      import('./portal/portal.module').then((m) => m.PortalModule),
  },
  {
    path: 'emergency',
    loadChildren: () =>
      import('./emergency/emergency.module').then((m) => m.EmergencyModule),
  },
  {
    path: 'print',
    canActivate: [Authorised],
    loadChildren: () =>
      import('./print/print.module').then((m) => m.PrintModule),
  },
  {
    path: '',
    canActivate: [Authorised],
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: '',
    canActivate: [Unauthorised],
    loadChildren: () =>
      import('./access/access.module').then((m) => m.AccessModule),
  },
]

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withNavigationErrorHandler((error) => {
        inject(ErrorHandler).handleError(error)
      })
    ),
    importProvidersFrom(BrowserModule, CoreModule),
    { provide: WINDOW, useValue: window },
    { provide: LOCAL_STORAGE, useValue: window.localStorage },
    {
      provide: BROADCAST_FACTORY,
      useValue: {
        echo: (options: EchoOptions<'reverb'>) => new Echo<'reverb'>(options),
        pusher: (key: string, options: Options) => new Pusher(key, options),
      },
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
      deps: [WINDOW],
    },
  ],
}
